webpackJsonp([252798981614480],{

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IntroParagraph = __webpack_require__(48);
	
	var _IntroParagraph2 = _interopRequireDefault(_IntroParagraph);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_IntroParagraph2.default, null),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Coming Soon'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Currently the only set of learning resources (Apps, book, quiz, resources) is Elm Accelerated. But I have ideas for other topics such as ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'Data in/for React'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'GLSL'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/elm', className: 'main-button elm-bg' },
	      'Elm Accelerated: Quiz, sample chapters and resources on Elm'
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/typescript', className: 'main-button elm-bg' },
	      'TypeScript Accelerated: sample chapters and resources on TypeScript'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-soon-js-bcbefc6f12f3810f6d75.js